import { render, staticRenderFns } from "./SafetyModal.vue?vue&type=template&id=f1ad1acc"
import script from "./SafetyModal.vue?vue&type=script&lang=ts"
export * from "./SafetyModal.vue?vue&type=script&lang=ts"
import style0 from "./SafetyModal.vue?vue&type=style&index=0&id=f1ad1acc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports